/* eslint-disable max-len */
import ConciliationOperations from './../conciliation-operations/index.vue';
import ConciliationTransfers from './../conciliation-transfers/index.vue';
import commonFunctions from '../common-functions';

export default {
    /**
     * Nombre del componente
     */
    name: 'ConciliationResume',

    extends: commonFunctions,

    components: { ConciliationTransfers, ConciliationOperations },

    data() {

        return {
            showDetails: false,
            comment: this.getComment,
            operationDate: this.$moment(new Date()).format('YYYY-MM-DD'),
            horaLimiteEnvioRD: this.$store.getters['configVarsStore/getConfigVar']('LIMIT_HOUR_RD_SEND') || '14',
            sendingToRD: false
        };
    },

    /**
     * @override
     */
    props: {
        monitorType: {
            type: String,
            required: false,
            default: 'all'
        }
    },
    created() {
        this.comment = this.getComment; // aparentemente no se usa
    },

    methods: {
        /**
         * @override
         */
        showDetailsAction() {
            this.showDetails = !this.showDetails;
            this.$nextTick(() => {
                this.$root.$emit('height_resume', this.$refs.resume.clientHeight);
            });
        },

        actionGroup(status) {
            if (!status) {
                return false;
            }

            const transactionsList = this.$store.getters['conciliationStore/transfers'];
            const operationsList = this.$store.getters['conciliationStore/operations'];

            const payload = {
                status,
                comment: this.comment,
                transactions: transactionsList.map(transaction => transaction.uuid),
                operations: operationsList.map(operation => operation.uuid)
            };

            if (this.groupedSelected) {
                this.$paymentsService
                    .patchConciliation(this.uuidGroupedSelected, payload)
                    .then(() => {
                        if (status === 'DESVINCULAR') {
                            this.$toast.success(`Desvinculado`, `Datos desvinculados con éxito.`);
                        } else {
                            this.$toast.success(`Guardado`, `Datos modificados con éxito.`);
                        }
                        this.clearSelection();
                    })
                    .catch(err => console.error(err));
            } else {
                this.$paymentsService
                    .setConciliation(payload)
                    .then(() => {
                        this.$toast.success(`Guardado`, `Agrupación guardada con éxito.`);
                        this.clearSelection();
                    })
                    .catch(err => console.error(err));
            }
        },

        cleanAll() {
            this.$store.dispatch('conciliationStore/setSuggestions', false);
            this.$store.dispatch('conciliationStore/setSearchBy', false);
            this.$root.$emit('set_filtering_operations');
            this.$root.$emit('set_filtering_transfers');
            this.clearSelection();
        },

        parseData() {
            const transactionData = {
                concept: [],
                iban_origin: [],
                payer: []
            };
            const operationData = {
                associated_accounts: [],
                intervenes: [],
                same_associated_accounts: [],
                same_Intervenes: []
            };

            this.transfers.forEach( tr => {
                transactionData.concept.push( tr.concept ? tr.concept.trim() : '' );
                transactionData.iban_origin.push( tr.iban_code_of_the_origin_account ? tr.iban_code_of_the_origin_account.trim() : '---');
                transactionData.payer.push( tr.name_of_payer ? tr.name_of_payer.trim() : '' );
            });

            this.operations.forEach( op => {
                if (op.bank_accounts) {
                    op.bank_accounts.forEach( account => operationData.associated_accounts.push( account.iban_code ? account.iban_code : '---'));
                } else {
                    operationData.associated_accounts.push(false);
                }
                if (op.interveners) {
                    op.interveners.forEach( intervener => operationData.intervenes.push( `${intervener.name || ''} ${intervener.lastname_1 || ''} ${intervener.lastname_2 || ''}`.toUpperCase().trim()));
                }
                if (op.match) {
                    operationData.same_associated_accounts.push( op.match.bank_account );
                    operationData.same_Intervenes.push( op.match.intervener );
                }
            });

            this.filterData(transactionData, operationData);
            return { transactionData, operationData };
        },

        filterData(transactionData, operationData) {
            operationData.same_associated_accounts = !operationData.same_associated_accounts.includes(false);
            operationData.same_Intervenes = !operationData.same_Intervenes.includes(false);
            operationData.amount = this.operationsAmmount;
            transactionData.amount = this.transfersAmmount;
        },

        compareAmounts(MARGIN_AMOUNT, transactionData, operationData) {
            if (   operationData.amount <= transactionData.amount + MARGIN_AMOUNT
                && operationData.amount >= transactionData.amount - MARGIN_AMOUNT
            ) {
                return true;
            } else {
                return false;
            }
        },

        canSendRD() {
            const operationsList = this.$store.getters['conciliationStore/operations'];
            const areAllValidatedOrSent = operationsList.every(operation => {
                return (operation.operation_status === 'VALIDATED' || operation.operation_status === 'RD_SENT' || operation.operation_status === 'FINALIZED')
                        &&
                        (operation.account_status === 'ENVIADO' || operation.account_status === 'FINALIZED');
            });
            return areAllValidatedOrSent;
        },

        /**
         * Cancela envio a RD (cierre de modal)
         */
        cancelSendOperationToRD() {
            this.$bvModal.hide('modalSendOperationToRDLate');
        },

        /**
         * Confirma envio a RD (cierre de modal y sendOperationToRD)
         */
        confirmSendOperationToRD() {
            this.$bvModal.hide('modalSendOperationToRDLate');
            this.sendOperationToRD(true);
        },

        async sendOperationsToRD(skipDate = false) {
            if (!this.canSendRD()) {
                return;
            }
            // Si la fecha es hoy y sobrepasa la hora límite de envío muestra la modal
            if (
                this.operationDate === this.$moment(new Date()).format('YYYY-MM-DD') &&
                this.$moment() > this.$moment(this.horaLimiteEnvioRD, 'h') &&
                !skipDate
            ) {
                this.$bvModal.show('modalSendOperationToRDLate');
            } else {
                // antes de enviar, actualizamos la fecha y si está todo OK se envía
                this.sendingToRD = true;
                try {
                    await this.updateOperationsDate();
                    await this.changeOperationsStatuses();
                    this.$toast.success('OK', 'Operaciones enviadas a RD correctamente');
                } catch (err) {
                    this.$toast.error(`Error ${err.name}`, `${err.message}`);
                }
                this.sendingToRD = false;
                this.cleanAll();
            }
        },

        /**
         * Update operations date
         * @return {Promise} response
         */
        async updateOperationsDate() {
            const operationsList = this.$store.getters['conciliationStore/operations'];
            const updatePromises = [];
            operationsList.forEach(operation => {
                if (operation.operation_status === 'VALIDATED') {
                    updatePromises.push(
                        this.$operationsService.updateOperation(operation.uuid, {
                            operation_date: this.operationDate
                        })
                    );
                }
            });
            try {
                await Promise.all(updatePromises);
            } catch (error) {
                throw error;
            }
        },

        /**
         * Update operation date
         * @return {Promise} response
         */
        async changeOperationsStatuses() {
            const operationsList = this.$store.getters['conciliationStore/operations'];
            const changeStatusPromises = [];
            operationsList.forEach(operation => {
                if (operation.operation_status === 'VALIDATED') {
                    changeStatusPromises.push(
                        this.$operationsService.changeOperationStatus(operation.uuid, {
                            status: 'RD_SENT',
                            sendToRD: true
                        })
                    );
                }
            });
            try {
                await Promise.all(changeStatusPromises);
            } catch (error) {
                throw error;
            }
        },

        /**
         * Crea operación a partir de una conciliación
         */
        createOperation() {
            const _route = {
                name: 'operations_add',
                params: [],
                query: {
                    uuid: this.transfers[0].uuid_periodic_request,
                    type: 'periodic'
                }
            };
            const item = {
                route: _route,
                name: 'Operaciones',
                active: true
            };
            this.$store.dispatch('yuriMenuStore/disableItemsMenu')
                .then(() => {
                    this.$store.dispatch('yuriMenuStore/upsertItem', item)
                        .then(() => {
                            this.$router.replace(item.route);
                        });
                    this.$store.dispatch('yuriMenuStore/setActiveItem', item);
                });
        }
    },

    computed: {
        transfers() {
            return this.$store.getters['conciliationStore/transfers'];
        },
        operations() {
            return this.$store.getters['conciliationStore/operations'];
        },

        transfersAmmount() {
            let total = 0;
            this.transfers.forEach(item => {
                total += +item.gross_amount;
            });
            return total;
        },
        operationsAmmount() {
            let total = 0;
            this.operations.forEach(item => {
                total += +item.gross_amount;
            });
            return total;
        },
        diffAmmount() {
            return this.transfersAmmount - this.operationsAmmount;
        },
        groupedSelected() {
            return this.$store.getters['conciliationStore/groupedSelected'];
        },
        uuidGroupedSelected() {
            return this.$store.getters['conciliationStore/uuidGroupedSelected'];
        },
        hasTransferAndOperations() {
            return this.transfers.length && this.operations.length;
        },
        getComment() {
            return this.$store.getters['conciliationStore/comment'];
        },
        canConciliate() {
            // Permitimos la conciliación con cualquier conbinación
            return true;
            // if (this.hasTransferAndOperations < 1) {
            //     return false;
            // }

            // const MARGIN_AMOUNT = this.$store.getters['conciliationStore/margin'];
            // const { transactionData, operationData } = this.parseData();
            // const validAmount = this.compareAmounts(MARGIN_AMOUNT, transactionData, operationData);

            // if (operationData.same_associated_accounts &&  operationData.same_Intervenes && validAmount) {
            //     return true;
            // }
            // if (operationData.same_associated_accounts && validAmount) {
            //     return true;
            // }
            // return false;
        },
        disableAll() {
            return this.$store.getters['conciliationStore/disableAll'];
        },
        canCreateOperation() {
            if (this.transfers.length !== 1) {
                return false;
            } else {
                return this.transfers[0].is_periodic;
            }
        }
    }
};
